import {http} from '../../../services/config';

export default {
    publicClientGetAtributesValidateAction({commit}, {context, companyId}) {
        http.get(`api/v1/publica/atributos/contexto/${context}`,
                {headers: {'company-id': companyId}}).then((resp) => {
            if (context === 'clients_phisical') {
                commit('publicClientAttrPhisicalValidateMutation', resp.data);
            } else if (context === 'clients_juridical') {
                commit('publicClientAttrJuridicalValidateMutation', resp.data);
            }
        });
    },
    listAnnexTypePublicAction: ({commit}, {companyId, vinculedAt = null}) => {
        http.get(`api/v1/publica/tiposAnexo/listar`, {headers: {'company-id': companyId}, params: {vinculedAt}})
                .then((resp) => {
                    let data = {'required': [], 'not_required': []};
                    resp.data.forEach(i => {
                        if (vinculedAt === 'fisica') {
                            if (i.required_on_person) {
                                data.required.push(i);
                            } else {
                                data.not_required.push(i);
                            }
                        } else {
                            if (i.required_on_person_juridical) {
                                data.required.push(i);
                            } else {
                                data.not_required.push(i);
                            }
                        }
                    })
                    commit('listAnnexTypePublicMutation', data);
                }).catch(() => commit('listAnnexTypePublicMutation', {'required': [], 'not_required': []}));
    },
    listMaritalStatusesPublicAction: ({commit}, {companyId}) => {
        http.get('api/v1/publica/estados-civis/listar', {
            headers: {
                'company-id': companyId,
            }
        }).then(resp => {
            commit('listMaritalStatusesPublicMutation', resp.data);
        }).catch(() => commit('listMaritalStatusesPublicMutation', []));
    },
    findClientPublicAction: ({commit}, {taxOrId, companyId}) => {
        commit('changeLoading', true)
        return http.get(`api/v1/publica/clientes/${taxOrId}`, {headers: {'company-id': companyId}});
    },
    createPublicClientAction({commit}, {client, companyId, key})
    {
        commit('changeLoading', true)
        return http.post('api/v1/publica/clientes', client, {
            headers: {
                'company-id': companyId,
                'authorization': key,
            },
        })
    }
}